export default __webpack_public_path__ + "static/progectImages2-7f52e9b5c3c7cb1dc59c31c1eed1f9f8.png";